import { Flex } from '@chakra-ui/react';
import { FormFeedback } from '@morressier/alembic';
import { Controller, get, useFormContext } from 'react-hook-form';
import { AffiliationCountryList } from 'src/api/queries';
import { FieldLabel } from 'src/components/Field';
import { CountrySearchSelect } from 'src/components/User/CountrySearchSelect';

const CustomCountrySelect = ({
  selectedCountry,
  setSelectedCountry,
  config,
  fieldPrefix
}: {
  selectedCountry: AffiliationCountryList | null;
  setSelectedCountry: (country: AffiliationCountryList) => void;
  config: any;
  fieldPrefix?: string;
}) => {
  const {
    formState: { errors },
    clearErrors
  } = useFormContext();

  const {
    caseDataFields: { main: field }
  } = config;

  const fieldName = fieldPrefix ? `${fieldPrefix}.country` : field;

  const error = get(errors, fieldName);

  const handleChange = (value: AffiliationCountryList) => {
    setSelectedCountry(value);
    clearErrors(fieldName);
  };

  return (
    <Flex flexDirection="column" gap={2} data-field-error={!!error}>
      <FieldLabel label="Country" isRequired subText="" />
      <Controller
        name={fieldPrefix ? `${fieldPrefix}.country` : field}
        rules={{
          required: 'Country is required'
        }}
        render={() => (
          <CountrySearchSelect
            value={selectedCountry}
            onChange={handleChange}
            isInvalid={error}
          />
        )}
      />
      {error && (
        <FormFeedback variant="error" data-error={`${fieldName}-error`}>
          {error?.message}
        </FormFeedback>
      )}
    </Flex>
  );
};

export default CustomCountrySelect;
